import React from 'react';
import PropTypes from 'prop-types';
import MobileMenus from 'components/nav/unauthenticated/mobile';
import MobileMenuToggle from 'components/nav/shared/MobileMenuToggle';
import NavCollapsible from 'components/nav/shared/NavCollapsible';
import NavLogo from 'components/nav/shared/NavLogo';
import UnauthenticatedItems from 'components/nav/unauthenticated/UnauthenticatedItems';

class UnauthenticatedNavBar extends React.Component {
  static propTypes = {
    isNavMenuOpen: PropTypes.bool.isRequired,
    hideJoinLink: PropTypes.bool,
  };

  render() {
    const { hideJoinLink, isNavMenuOpen } = this.props;
    return (
      <nav className="aa-navbar-first navbar navbar-inverse navbar-static-top">
        <div className="container-fluid">
          <div className="content">
            <MobileMenuToggle isNavMenuOpen={isNavMenuOpen} />
            <NavLogo />

            {/* Mobile menu logic, xs screen size only */}
            <div className="remove-padding-xs hidden-sm hidden-md hidden-lg">
              <NavCollapsible
                className="navbar-right"
                menuProps={{ hideJoinLink }}
                menus={MobileMenus}
                isNavMenuOpen={isNavMenuOpen}
              />
            </div>

            {/* Right side items, hidden on xs */}
            <div className="navbar-right hidden-xs">
              <UnauthenticatedItems hideJoinLink={hideJoinLink} />
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default UnauthenticatedNavBar;
